import React, { useState } from "react";
import { withBundle, WithBundleProps } from "@amzn/react-arb-tools";
import CloudScapeModal from "@cloudscape-design/components/modal";
import CloudScapeBox from "@cloudscape-design/components/box";
import CloudSpaceBetween from "@cloudscape-design/components/space-between";
import CloudScapeButton from "@cloudscape-design/components/button";
import CloudScapeAlert from "@cloudscape-design/components/alert";
import { OrangeButton } from "../Buttons/CustomizedButtons";

interface DeleteModalProps extends WithBundleProps {
  selectedRecords: any[]; //todo I will change this any during API integration
  deleteModalOpen: boolean;
  setDeleteModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  page: string;
}

export const DeleteModal = withBundle("components.DeleteModal")(
  (props: DeleteModalProps) => {
    const [deleting, setDeleting] = useState<boolean>(false);

    //Delete API operation comes here using props.selectedRecords

    const getFooter = () => (
      <CloudScapeBox float="right">
        <CloudSpaceBetween direction="horizontal" size="xs">
          <CloudScapeButton
            variant="link"
            onClick={() => props.setDeleteModalOpen(false)}
          >
            {props.bundle.getMessage("cancel")}
          </CloudScapeButton>
          <OrangeButton
            variant="primary"
            onClick={() => setDeleting(true)}
            loading={deleting}
            disabled={deleting}
          >
            {props.bundle.getMessage("delete")}
          </OrangeButton>
        </CloudSpaceBetween>
      </CloudScapeBox>
    );

    return props.deleteModalOpen && props.selectedRecords.length > 0 ? (
      <CloudScapeModal
        onDismiss={() => props.setDeleteModalOpen(false)}
        visible={props.deleteModalOpen}
        footer={getFooter()}
        header={props.bundle.formatMessage(
          `delete_modal_header_context_for_${props.page}`,
          { numRecords: props.selectedRecords!.length }
        )}
      >
        {props.bundle.formatMessage(`delete_modal_info_content_${props.page}`, {
          numRecords: props.selectedRecords.length,
          div: (child: string) => <div key="1">{child}</div>,
          strong: (child: string) => <strong key="1">{child}</strong>,
        })}
        <br />
        <CloudScapeAlert statusIconAriaLabel="Info">
          {props.bundle.formatMessage("delete_modal_info_alert_content", {
            page: props.page,
            div: (child: string) => <div key="1">{child}</div>,
          })}
        </CloudScapeAlert>
      </CloudScapeModal>
    ) : (
      <></>
    );
  }
);
